import { percentageValidation } from './percentageMetrics'
const checkName = (name) => (!name ? `Please assign a heatmap name` : false)

const checkUserId = (userId) => (!userId ? `userID is not available` : false)

const checkType = (type) => (!type ? `Please assign a heatmap type` : false)

const checkAMetric = (fieldName, dynamicfield, calc) => {
  // To allow for less than 4 metrics (in case there are less than 4 numerical dynamicfields)
  if (!dynamicfield && !calc) return `Both Empty`

  // Number
  if (fieldName.includes('number')) {
    if (!dynamicfield) return `Please select pin data for Number`
    if (!calc) return `Please select pin value for Number`

    return false
  }

  // Size
  if (fieldName.includes('size')) {
    if (!dynamicfield) return `Please select pin data for Size`
    if (!calc) return `Please select pin value for Size`

    return false
  }

  // color
  if (fieldName.includes('color')) {
    if (!dynamicfield) return `Please select pin data for color`
    if (!calc) return `Please select pin value for color`

    return false
  }

  // shadow
  if (fieldName.includes('shadow')) {
    if (!dynamicfield) return `Please select pin data for shadow`
    if (!calc) return `Please select pin value for shadow`

    return false
  }

  return false
}

const normalizeHex = (hex) => {
  if (!hex) return null
  let h = String(hex).trim()
  if (h.startsWith('#')) h = h.slice(1)
  if (h.length === 3) h = h.split('').map((c) => c + c).join('')
  h = h.toUpperCase()
  return /^[0-9A-F]{6}$/.test(h) ? `#${h}` : null
}

const normalizePalette = (colors) => {
  const arr = Array.isArray(colors) ? colors.slice(0, 4) : []
  if (arr.length != 4) return null
  const norm = arr.map(normalizeHex)
  return norm.every(Boolean) ? norm : null
}

const checkMetrics = (metricsFields) => {
  /**
   * if only one is available,  it is still acceptable(at least 1 metric is required)
   * for each metric either both empty or both selected (dynamicField, calc)
   */

  //  Number
  const numberValidationMessage = checkAMetric(
    'number',
    metricsFields['number']['field'],
    metricsFields['number']['calc']
  )

  // requires all 4 metrics to be available
  // if (numberValidationMessage) return numberValidationMessage

  // To allow for  less than 4 metrics (in case there are less than 4 numerical dynamicfields)
  if (numberValidationMessage && numberValidationMessage !== 'Both Empty')
    return numberValidationMessage

  // Size
  const sizeValidationMessage = checkAMetric(
    'size',
    metricsFields['size']['field'],
    metricsFields['size']['calc']
  )

  // requires all 4 metrics to be available
  // if (sizeValidationMessage) return sizeValidationMessage

  // To allow for less than 4 metrics (in case there are less than 4 numerical dynamicfields)
  if (sizeValidationMessage && sizeValidationMessage !== 'Both Empty')
    return sizeValidationMessage

  // Color
  const colorValidationMessage = checkAMetric(
    'color',
    metricsFields['color']['field'],
    metricsFields['color']['calc']
  )

  // requires all 4 metrics to be available
  // if (colorValidationMessage) return colorValidationMessage

  // To allow for less than 4 metrics (in case there are less than 4 numerical dynamicfields)
  if (colorValidationMessage && colorValidationMessage !== 'Both Empty')
    return colorValidationMessage

  // Shadow
  const shadowValidationMessage = checkAMetric(
    'shadow',
    metricsFields['shadow']['field'],
    metricsFields['shadow']['calc']
  )

  // requires all 4 metrics to be available
  // if (shadowValidationMessage) return shadowValidationMessage

  // To allow for less than 4 metrics (in case there are less than 4 numerical dynamicfields)
  if (shadowValidationMessage && shadowValidationMessage !== 'Both Empty')
    return shadowValidationMessage

  /**
   * No Metric
   */
  if (
    numberValidationMessage === 'Both Empty' &&
    sizeValidationMessage === 'Both Empty' &&
    colorValidationMessage === 'Both Empty' &&
    shadowValidationMessage === 'Both Empty'
  )
    return 'Please Choose at least 1 metric'

  return false
}

const validationFunctions = (formFields) => ({
  userId: () => checkUserId(formFields['userId']),
  name: () => checkName(formFields['name']),
  type: () => checkType(formFields['heatmapType']),
  metrics: () =>
    checkMetrics({
      number: {
        field: formFields['numberField'],
        calc: formFields['numberCalc']
      },
      size: {
        field: formFields['sizeField'],
        calc: formFields['sizeCalc']
      },
      color: {
        field: formFields['colorField'],
        calc: formFields['colorCalc']
      },
      shadow: {
        field: formFields['shadowField'],
        calc: formFields['shadowCalc']
      }
    })
})

export const getFormValidationMessage = (formFields, fields = []) => {
  const percentageError = percentageValidation(formFields, fields)
  if (percentageError) return percentageError
  const mandatoryFields = ['name', 'type', 'userId', 'metrics']
  const validationFuncs = validationFunctions(formFields)

  for (const field of mandatoryFields) {
    const func = validationFuncs[field]
    const validationMessage = (func && func()) || undefined

    if (validationMessage) return validationMessage
  }

  return false
}

export const getRequestData = (formFields) => ({
  name: formFields['name'],
  description: formFields['description'] || null,
  type: formFields['heatmapType'],
  owner_ids: (formFields['heatmapType']==='system' ? [] : [formFields['userId']]),
  group_ids: [],
  metrics: ['number', 'size', 'color', 'shadow']
    .map((item) => {
      return (
        formFields[`${item}Field`] && {
          field_id: formFields[`${item}Field`] || null,
          label: formFields[`${item}FieldLabel`] || '',
          ref: item,
          calc: formFields[`${item}Calc`] || null,
          ranges: formFields[`${item}Slider`] || [],
          ...(item === 'color' && {
            color_hexes: normalizePalette(formFields['colorHexes']) ||
            ['#549FF5', '#1DBE1D', '#FDD71A', '#ED1C24']
          })
        }
      )
    })
    .filter((item) => !!item),
  suspended_at: null
})
